export default __webpack_public_path__ + "static/media/like.6752cdc7.svg";